 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"about-contact-us-about-contact-us-module":"about-contact-us-about-contact-us-module","admin-setting-admin-setting-module~admin-stores-admin-stores-module~bank-bank-module~bid-dashboard-b~a21c041d":"admin-setting-admin-setting-module~admin-stores-admin-stores-module~bank-bank-module~bid-dashboard-b~a21c041d","admin-setting-admin-setting-module~admin-stores-admin-stores-module~bid-dashboard-bid-dashboard-modu~68c01f14":"admin-setting-admin-setting-module~admin-stores-admin-stores-module~bid-dashboard-bid-dashboard-modu~68c01f14","admin-setting-admin-setting-module~admin-stores-admin-stores-module~export-export-module~order-order~e6e10756":"admin-setting-admin-setting-module~admin-stores-admin-stores-module~export-export-module~order-order~e6e10756","admin-stores-admin-stores-module~export-export-module~inventory-inventory-module~request-demo-reques~bd5e6737":"admin-stores-admin-stores-module~export-export-module~inventory-inventory-module~request-demo-reques~bd5e6737","admin-stores-admin-stores-module~home-page-home-page-module~partner-register-partner-register-module~59807f24":"admin-stores-admin-stores-module~home-page-home-page-module~partner-register-partner-register-module~59807f24","admin-stores-admin-stores-module~request-demo-request-demo-module":"admin-stores-admin-stores-module~request-demo-request-demo-module","common":"common","admin-stores-admin-stores-module":"admin-stores-admin-stores-module","request-demo-request-demo-module":"request-demo-request-demo-module","admin-setting-admin-setting-module~export-export-module~inventory-inventory-module~system-configurat~b4665c69":"admin-setting-admin-setting-module~export-export-module~inventory-inventory-module~system-configurat~b4665c69","admin-setting-admin-setting-module~export-export-module~inventory-inventory-module":"admin-setting-admin-setting-module~export-export-module~inventory-inventory-module","admin-setting-admin-setting-module~system-configuration-system-configuration-module":"admin-setting-admin-setting-module~system-configuration-system-configuration-module","admin-setting-admin-setting-module":"admin-setting-admin-setting-module","bid-dashboard-bid-dashboard-module~dashboard-dashboard-module~export-export-module~inventory-invento~f460c3e1":"bid-dashboard-bid-dashboard-module~dashboard-dashboard-module~export-export-module~inventory-invento~f460c3e1","bid-dashboard-bid-dashboard-module~export-export-module~inventory-inventory-module":"bid-dashboard-bid-dashboard-module~export-export-module~inventory-inventory-module","export-export-module~inventory-inventory-module~system-configuration-system-configuration-module":"export-export-module~inventory-inventory-module~system-configuration-system-configuration-module","export-export-module~inventory-inventory-module":"export-export-module~inventory-inventory-module","export-export-module~order-order-module":"export-export-module~order-order-module","export-export-module":"export-export-module","term-condition-term-condition-module":"term-condition-term-condition-module","bid-dashboard-bid-dashboard-module~dashboard-dashboard-module":"bid-dashboard-bid-dashboard-module~dashboard-dashboard-module","bid-dashboard-bid-dashboard-module":"bid-dashboard-bid-dashboard-module","import-import-module":"import-import-module","item-special-item-special-module":"item-special-item-special-module","wallet-wallet-module":"wallet-wallet-module","system-configuration-system-configuration-module":"system-configuration-system-configuration-module","partner-register-partner-register-module":"partner-register-partner-register-module","bank-bank-module~user-access-user-access-module":"bank-bank-module~user-access-user-access-module","bank-bank-module":"bank-bank-module","dashboard-dashboard-module":"dashboard-dashboard-module","brand-discount-brand-discount-module":"brand-discount-brand-discount-module","customer-review-customer-review-module":"customer-review-customer-review-module","join-as-partner-join-as-partner-module":"join-as-partner-join-as-partner-module","login-login-module":"login-login-module","notifications-notifications-module":"notifications-notifications-module","order-order-module":"order-order-module","home-page-home-page-module":"home-page-home-page-module","authentication-authentication-module":"authentication-authentication-module","profile-profile-module":"profile-profile-module","signup-signup-module":"signup-signup-module","form-forms-module":"form-forms-module","icons-icons-module":"icons-icons-module","system-maintenance-system-maintenance-module":"system-maintenance-system-maintenance-module","table-tables-module":"table-tables-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');

 				script.charset = 'utf-8';
 				script.timeout = 120;

 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				function onScriptComplete(event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
